import React from 'react';
import {getCssVarValue} from '@src/helpers/getCssVarValue';
import {parseDate} from '@src/helpers/dates';
import StatusColorListIndicator from '@views/orders/fields/StatusColorListIndicator';
import {IOrderProductModel} from '@src/@interfaces/models/Order/IOrderProductModel';

export default function OrderProductsListStatusIndicator<Model extends IOrderProductModel>(
        {model}: { model: Model | undefined, rowIndex: number }
) {
    const deadlineAt = model?.deadline_at ? parseDate(model?.deadline_at) : null;
    const isExpired = (!model?.status?.is_completed && deadlineAt != null) && deadlineAt.toDate().getTime() < Date.now();

    let color = model?.status?.bg_color;
    if (isExpired) {
        color = getCssVarValue('--bs-danger', '#f00');
    }

    return <td className="p-0">
        <StatusColorListIndicator
                color={color}
                margin={'5px 0 5px 5px'}
                pulse={isExpired}
        />
    </td>;
}
